var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconActionItems(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.639,
    height: 19,
    viewBox: "0 0 21.639 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu_Icon_Action_Items",
    transform: "translate(-2.5 -8.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36293",
    "data-name": "Path 36293",
    d: "M32.128,59.3l-3.486,5.468a1.229,1.229,0,0,0,.387,1.709,1.182,1.182,0,0,0,.66.2,1.24,1.24,0,0,0,1.048-.57l3.417-5.354-.934-.432A2.636,2.636,0,0,1,32.128,59.3Z",
    transform: "translate(-20.037 -39.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36294",
    "data-name": "Path 36294",
    d: "M76.073,10.487A2.187,2.187,0,1,1,73.886,8.3a2.187,2.187,0,0,1,2.187,2.187",
    transform: "translate(-53.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36295",
    "data-name": "Path 36295",
    d: "M51.527,28.506a1.063,1.063,0,0,0-1.276-.729l-1.526.433-.752-1.686a2.9,2.9,0,0,0-1.048-1.23l-1.777-1.162a2.9,2.9,0,0,0-1.777-.456l-2.619.2a1.073,1.073,0,0,0-.707.365l-1.777,2.1a1.034,1.034,0,0,0,1.572,1.344l1.5-1.777,1.572-.114L40.659,29.85a1.229,1.229,0,0,0-.091.98,1.338,1.338,0,0,0,.66.752l3.486,1.64-1.936,2.643a1.242,1.242,0,0,0,.273,1.732,1.225,1.225,0,0,0,1.731-.25l2.825-3.873a1.244,1.244,0,0,0-.479-1.869l-2.437-1.162,1.686-2.483.843,1.891a1.021,1.021,0,0,0,.957.615,1.169,1.169,0,0,0,.273-.045l2.392-.66a1,1,0,0,0,.686-1.255Z",
    transform: "translate(-27.429 -11.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36296",
    "data-name": "Path 36296",
    d: "M9.911,25.522h4.215a.911.911,0,1,0,0-1.823H9.911a.911.911,0,0,0,0,1.823Z",
    transform: "translate(-5.019 -11.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36297",
    "data-name": "Path 36297",
    d: "M6.61,43.425h4.215a.911.911,0,1,0,0-1.823H6.61a.914.914,0,0,0-.911.911A.93.93,0,0,0,6.61,43.425Z",
    transform: "translate(-2.47 -25.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36298",
    "data-name": "Path 36298",
    d: "M7.6,59.5H3.411a.911.911,0,1,0,0,1.823H7.626a.914.914,0,0,0,.911-.911A.934.934,0,0,0,7.6,59.5Z",
    transform: "translate(0 -39.535)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconActionItems);
export default __webpack_public_path__ + "static/media/Menu_Icon_Action_Items.3da1b9f8.svg";
export { ForwardRef as ReactComponent };